<template>
    <div
        :class="[
            'viewactions',
            size.length ? `viewactions--${size}` : '',
            raw ? 'viewactions--raw' : ''
        ]"
    >
        <div class="container">
            <template v-if="breadcrumbActive">
                <div class="columns is-variable">
                    <div class="column">
                        <component-breadcrumbs
                            :items="breadcrumbItems"
                        />
                    </div>
                </div>
            </template>
            <div class="viewactions__inner">
                <div class="columns is-block-mobile custom--columns is-vcentered">
                    <div class="column">
                        <h2 class="viewactions__inner_title">{{ title }}</h2>
                    </div>
                    <template v-if="customHintActive">
                        <div class="column column--center is-narrow">
                            <div class="viewactions__inner_inner_customhint">
                                <component-button
                                    :theme="'default'"
                                    :text="true"
                                    :icon="!!customHintIcon"
                                    :icon-name="customHintIcon"
                                    @click="emitCustomHint"
                                    :name="'viewactions-inner-inner-customhint'"
                                    :size="'tiny'"
                                >{{ customHintText }}
                                </component-button>
                            </div>
                        </div>
                    </template>
                    <template v-if="switcherActive">
                        <div class="column is-narrow">
                            <div class="viewactions__inner_switcher">
                                <form-checkbox
                                    :label="''"
                                    :name="'viewactions-switcher'"
                                    :switcher="true"
                                    :disabled="switcherDisabled"
                                    :value="switcherValue"
                                    @click="emitSwitcher"
                                ></form-checkbox>
                            </div>
                        </div>
                    </template>
                    <template v-if="statusActive && visibility(statusVisibility)">
                        <div class="column column--center is-narrow">
                            <div class="viewactions__inner_status">
                                <component-status :status="statusName"/>
                            </div>
                        </div>
                    </template>
                    <template v-if="
                        visibility(actionButtonVisibility) &&
                        actionButtonActive &&
                        (
                            trashButtonActive ||
                            cancelButtonActive ||
                            customButtonActive ||
                            submitButtonActive ||
                            linkButtonActive ||
                            menuButtonActive ||
                            hintButtonActive
                        )
                    ">
                        <div class="column is-narrow">
                            <div class="viewactions__inner_buttons">
                                <div class="columns is-block-mobile columns--margin-1-mobile is-vcentered">
                                    <template v-if="trashButtonActive && visibility(trashButtonVisibility)">
                                        <div class="column">
                                            <component-button
                                                :classes="'viewactions__inner_buttons_remove'"
                                                :name="'viewactions-inner-buttons-remove'"
                                                :icon="true"
                                                :theme="'default'"
                                                :icon-name="'trash-2'"
                                                :align="'left'"
                                                @click="emitRemove"
                                            />
                                        </div>
                                    </template>
                                    <template v-if="cancelButtonActive">
                                        <div class="column">
                                            <component-button
                                                :theme="'default'"
                                                :border="true"
                                                :classes="'viewactions__inner_buttons_cancel'"
                                                :name="'viewactions-inner-buttons-cancel'"
                                                :align="'left'"
                                                @click="emitCancel"
                                            >{{cancelButtonText}}
                                            </component-button>
                                        </div>
                                    </template>
                                    <template v-if="customButtonActive">
                                        <div class="column">
                                            <component-button
                                                :theme="customButtonDanger ? '' : customButtonTheme"
                                                :border="true"
                                                :classes="'viewactions__inner_buttons_custom'"
                                                :name="'viewactions-inner-buttons-custom'"
                                                :danger="customButtonDanger"
                                                :disabled="customButtonDisabled"
                                                :animate-loading="customButtonAnimateLoading"
                                                :animate-loading-event-name="customButtonAnimateLoadingEventName"
                                                :align="'left'"
                                                :list-active="customButtonListActive"
                                                :list-items="customButtonListItems"
                                                @click="emitCustom"
                                                @emit="handleMenuButtonEmit"
                                            >{{customButtonText}}
                                            </component-button>
                                        </div>
                                    </template>
                                    <template v-if="submitButtonActive && visibility(submitButtonVisibility)">
                                        <div class="column">
                                            <component-button
                                                :theme="submitButtonTheme"
                                                :classes="'viewactions__inner_buttons_submit'"
                                                :disabled="submitButtonDisabled"
                                                :name="'viewactions-inner-buttons-submit'"
                                                :icon="submitButtonIcon"
                                                :icon-name="submitButtonIconName"
                                                :icon-align="submitButtonIconAlign"
                                                :animate-loading="submitButtonAnimateLoading"
                                                :animate-loading-event-name="submitButtonAnimateLoadingEventName"
                                                :align="'left'"
                                                :list-active="submitButtonListActive"
                                                :list-items="submitButtonListItems"
                                                @click="emitSubmit"
                                                @emit="handleMenuButtonEmit"
                                            >{{submitButtonText}}
                                            </component-button>
                                        </div>
                                    </template>
                                    <template v-if="linkButtonActive">
                                        <div class="column">
                                            <component-button
                                                :classes="'viewactions__inner_buttons_link'"
                                                :name="'viewactions-inner-buttons-link'"
                                                :to="linkButtonTo"
                                            >{{linkButtonText}}
                                            </component-button>
                                        </div>
                                    </template>
                                    <template v-if="menuButtonActive">
                                        <div class="column">
                                            <component-button-menu
                                                :classes="'viewactions__inner_buttons_menu'"
                                                :name="'viewactions-inner-buttons-menu'"
                                                :buttons="menuButtonItems"
                                                :align="'left'"
                                                @emit="handleMenuButtonEmit"
                                            ></component-button-menu>
                                        </div>
                                    </template>
                                    <template v-if="hintButtonActive">
                                        <div class="column">
                                            <component-button
                                                :classes="'viewactions__inner_buttons_remove'"
                                                :name="'viewactions-inner-buttons-remove'"
                                                :icon="true"
                                                :icon-name="'help-circle'"
                                                @click="emitRemove"
                                            />
                                        </div>
                                    </template>
                                </div>
                            </div>
                        </div>
                    </template>
                </div>
            </div>
        </div>
        <template v-if="visibility(actionButtonVisibility)">
            <pop-notify
                ref="popnotifyremove"
                v-if="trashButtonActive && trashNotifyActive && visibility(trashButtonVisibility)"
                :class="'pop__notify--archive'"
                :title-text="`${popNotifyRemoveTitleText}`"
                :content-text="`${popNotifyRemoveContentText}`"
                :cancel-button-text="$t('shared.viewAction.notify.cancel')"
                :submit-button-text="`${trashNotifyProcess}`"
                :submit-button-danger="true"
                :prevent-close="trashNotifyPreventClose"
                @emit-submit="emitNotifyRemoveSubmit"
            />
            <pop-notify
                v-if="cancelButtonActive && cancelNotifyActive"
                ref="popnotifycancel"
                :class="'pop__notify--cancel'"
                :title-text="cancelNotifyTitleText || `${toCapitalize(notifyProcess)} ${notifyTitle}`"
                :content-text="cancelNotifyContentText || `${this.$t('shared.viewAction.notify.contentDoYouWant')} ${notifyProcess} ${this.$t('shared.viewAction.notify.contentThis')} ${notifyTitle}?`"
                :cancel-button-text="$t('shared.viewAction.notify.cancel')"
                :submit-button-text="cancelNotifySubmitText"
                :submit-button-danger="cancelNotifySubmitDanger"
                @emit-submit="emitNotifyCancelSubmit"
            />
            <pop-notify
                v-if="customNotifyActive"
                ref="popnotifycustom"
                :class="'pop__notify--submit'"
                :title-text="customNotifyTitle"
                :content-text="customNotifyText"
                :prevent-close="customNotifyPreventClose"
                :cancel-button-text="customNotifyCancelText"
                :custom-button-active="customNotifyCustomActive"
                :custom-button-text="customNotifyCustomText"
                :custom-button-danger="customNotifyCustomDanger"
                :custom-button-animate-loading="customNotifyCustomAnimateLoading"
                :submit-button-active="customNotifySubmitActive"
                :submit-button-text="customNotifySubmitText"
                :submit-button-danger="customNotifySubmitDanger"
                :submit-button-animate-loading="customNotifySubmitAnimateLoading"
                :submit-button-animate-loading-name="customNotifySubmitAnimateLoadingName"
                :select-active="customNotifySelectActive"
                :select-title="customNotifySelectTitle"
                :select-items="customNotifySelectItems"
                :select-hint="customNotifySelectHint"
                :size="customNotifySize"
                @emit-custom="emitNotifyCustomCustom"
                @emit-submit="emitNotifyCustomSubmit"
            />
        </template>
    </div>
</template>

<script>
import PopNotify from '@/components/default/shared/PopNotify'
import ComponentBreadcrumbs from '@/components/default/shared/ComponentBreadcrumbs'
import ComponentStatus from '@/components/default/shared/ComponentStatus'
import { User } from '@/User'
import ComponentButton from '@/components/default/shared/ComponentButton'
import { toLowerCase } from '@/functions'
import FormCheckbox from '@/components/default/forms/FormCheckbox'
import ComponentButtonMenu from '@/components/default/shared/ComponentButtonMenu'

export default {
  components: {
    ComponentButtonMenu,
    FormCheckbox,
    ComponentButton,
    ComponentStatus,
    ComponentBreadcrumbs,
    PopNotify
  },
  name: 'view-actions',
  data () {
    return {
      user: new User()
    }
  },
  computed: {
    popNotifyRemoveTitleText () {
      return `${this.trashNotifyProcess} ${this.popNotifyItemName}`
    },
    popNotifyItemName () {
      return this.notifyTitle ? `${this.notifyTitle}` : (this.trashNotifyMultiple ? this.$tc('shared.viewAction.notify.itemName', 2) : this.$tc('shared.viewAction.notify.itemName', 1))
    },
    popNotifyRemoveContentText () {
      return this.trashNotifyContent || `${this.$t('shared.viewAction.notify.contentDoYouWant')} ${toLowerCase(this.trashNotifyProcess)} ${this.trashNotifyMultiple ? toLowerCase(this.$t('shared.viewAction.notify.contentSelected')) : toLowerCase(this.$t('shared.viewAction.notify.contentThis'))} ${(this.popNotifyItemName)}?`
    }
  },
  props: {
    title: {
      type: [String, Array]
    },
    size: {
      type: String,
      default: ''
    },
    //
    breadcrumbActive: {
      type: Boolean,
      default: false
    },
    breadcrumbName: {
      type: String,
      default: ''
    },
    breadcrumbTo: {
      type: [Array, Object],
      default: () => {
      }
    },
    breadcrumbItems: {
      type: [Array, Object],
      default: () => []
    },
    //
    statusActive: {
      type: Boolean,
      default: false
    },
    statusName: {
      type: String,
      default: ''
    },
    // one of roles from User.js
    statusVisibility: {
      type: [Array],
      default: () => []
    },
    //
    notifyTitle: {
      type: String,
      default: ''
    },
    notifyProcess: {
      type: String,
      default: 'edit'
    },
    //
    trashNotifyActive: {
      type: Boolean,
      default: true
    },
    trashNotifyMultiple: {
      type: Boolean,
      default: false
    },
    trashNotifyPreventClose: {
      type: Boolean,
      default: false
    },
    trashNotifyProcess: {
      type: String,
      default: function () {
        return this.$t('shared.viewAction.notify.archive')
      }
    },
    trashNotifyContent: {
      type: String
    },
    trashButtonActive: {
      type: Boolean,
      default: false
    },
    trashButtonModal: {
      type: String,
      default: 'deleteModal'
    },
    // one of roles from User.js
    trashButtonVisibility: {
      type: [Array],
      default: () => []
    },
    //
    hintButtonActive: {
      type: Boolean,
      default: false
    },
    hintButtonContent: {
      type: String
    },
    //
    cancelButtonActive: {
      type: Boolean,
      default: true
    },
    cancelButtonText: {
      type: String,
      default: function () {
        return this.$t('shared.viewAction.props.cancel')
      }
    },
    cancelButtonModal: {
      type: String,
      default: 'cancelModal'
    },
    cancelNotifyActive: {
      type: Boolean,
      default: true
    },
    cancelNotifyTitleText: {
      type: String
    },
    cancelNotifyContentText: {
      type: String
    },
    cancelNotifySubmitText: {
      type: String,
      default: 'Confirm'
    },
    cancelNotifySubmitDanger: {
      type: Boolean,
      default: false
    },
    //
    customHintActive: {
      type: Boolean,
      default: false
    },
    customHintText: {
      type: String,
      default: ''
    },
    customHintIcon: {
      type: String,
      default: ''
    },
    customButtonActive: {
      type: Boolean,
      default: false
    },
    customButtonTheme: {
      type: String,
      default: 'default'
    },
    customButtonListActive: {
      type: Boolean,
      default: false
    },
    customButtonListItems: {
      type: Array,
      default: () => []
    },
    customButtonDanger: {
      type: Boolean,
      default: false
    },
    customButtonDisabled: {
      type: Boolean,
      default: false
    },
    customButtonAnimateLoading: {
      type: Boolean,
      default: false
    },
    customButtonAnimateLoadingEventName: {
      type: String,
      default: 'view-action-custom'
    },
    customButtonText: {
      type: String,
      default: function () {
        return this.$t('shared.viewAction.props.custom')
      }
    },
    customNotifyActive: {
      type: Boolean,
      default: false
    },
    customNotifyTitle: {
      type: String,
      default: function () {
        return this.$t('shared.viewAction.props.customTitle')
      }
    },
    customNotifyText: {
      type: String,
      default: function () {
        return this.$t('shared.viewAction.props.customText')
      }
    },
    customNotifySize: {
      type: String
    },
    customNotifyCancelText: {
      type: String,
      default: function () {
        return this.$t('shared.viewAction.props.cancel')
      }
    },
    customNotifyCustomActive: {
      type: Boolean,
      default: false
    },
    customNotifyCustomText: {
      type: String,
      default: function () {
        return this.$t('shared.viewAction.props.custom')
      }
    },
    customNotifyCustomDanger: {
      type: Boolean,
      default: false
    },
    customNotifyCustomAnimateLoading: {
      type: Boolean,
      default: true
    },
    customNotifySubmitActive: {
      type: Boolean,
      default: true
    },
    customNotifySubmitText: {
      type: String,
      default: function () {
        return this.$t('shared.viewAction.props.confirm')
      }
    },
    customNotifySubmitDanger: {
      type: Boolean,
      default: false
    },
    customNotifySubmitAnimateLoading: {
      type: Boolean,
      default: true
    },
    customNotifySubmitAnimateLoadingName: {
      type: String
    },
    customNotifySelectActive: {
      type: Boolean,
      default: false
    },
    customNotifySelectTitle: {
      type: String,
      default: ''
    },
    customNotifySelectItems: {
      type: [Array, Object],
      default: () => {
      }
    },
    customNotifySelectHint: {
      type: String,
      default: ''
    },
    customNotifyPreventClose: {
      type: Boolean,
      default: false
    },
    //
    submitButtonActive: {
      type: Boolean,
      default: true
    },
    submitButtonText: {
      type: String,
      default: function () {
        return this.$t('shared.viewAction.props.create')
      }
    },
    submitButtonTheme: {
      type: String,
      default: 'primary'
    },
    submitButtonListActive: {
      type: Boolean,
      default: false
    },
    submitButtonListItems: {
      type: Array,
      default: () => []
    },
    submitButtonIcon: {
      type: Boolean
    },
    submitButtonIconName: {
      type: String
    },
    submitButtonIconAlign: {
      type: String
    },
    submitButtonAnimateLoading: {
      type: Boolean,
      default: false
    },
    submitButtonAnimateLoadingEventName: {
      type: String,
      default: 'view-action-submit'
    },
    // one of roles from User.js
    submitButtonVisibility: {
      type: [Array],
      default: () => []
    },
    submitButtonDisabled: {
      type: Boolean,
      default: false
    },
    menuButtonActive: {
      type: Boolean,
      default: false
    },
    menuButtonItems: {
      type: Array,
      default: () => []
    },
    //
    linkButtonActive: {
      type: Boolean,
      default: false
    },
    linkButtonText: {
      type: String,
      default: function () {
        return this.$t('shared.viewAction.props.edit')
      }
    },
    linkButtonTo: {
      type: Object
    },
    linkButtonOutline: {
      type: Boolean,
      default: false
    },
    //
    actionButtonVisibility: {
      type: [Array],
      default: () => []
    },
    actionButtonActive: {
      type: Boolean,
      default: true
    },
    switcherActive: {
      type: Boolean,
      default: false
    },
    switcherDisabled: {
      type: Boolean,
      default: false
    },
    switcherValue: {
      type: [String, Boolean]
    },
    raw: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    visibility (roles) {
      if (!roles.length) {
        return true
      }
      const userRoles = this.user.listPermissions()
      return roles.some(value => userRoles.includes(value))
    },
    //
    emitSwitcher () {
      this.$emit('emit-switcher')
    },
    emitCustomHint () {
      this.$emit('emit-custom-hint')
    },
    emitRemove () {
      if (this.trashNotifyActive) {
        this.$refs.popnotifyremove.openNotify()
      } else {
        this.$emit('emit-remove')
      }
    },
    emitCancel () {
      if (this.cancelNotifyActive) {
        this.$refs.popnotifycancel.openNotify()
      }
      this.$emit('emit-cancel')
    },
    emitCustom (event) {
      if (this.customNotifyActive) {
        this.$refs.popnotifycustom.openNotify()
      }
      this.$emit('emit-custom', event)
    },
    emitSubmit (event) {
      this.$emit('emit-submit', event)
    },
    emitNotifyCancelSubmit () {
      this.$emit('emit-notify-cancel-submit')
    },
    emitNotifyCustomCustom () {
      this.$emit('emit-notify-custom-custom')
    },
    emitNotifyCustomSubmit () {
      this.$emit('emit-notify-custom-submit')
    },
    emitNotifyRemoveSubmit () {
      this.$emit('emit-notify-remove-submit')
    },
    handleMenuButtonEmit (name) {
      this.$emit(`emit-${name}`)
    }
  }
}
</script>

<style lang="scss">
    @import "~@/assets/scss/components/default/shared/viewactions";
</style>
